export default "__VITE_ASSET__B5LhH73Y__"